import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { ThemeContext } from "../../../App";
import { MdOutlineDeleteForever, MdModeEdit } from "react-icons/md";
import AddAdminModal from "../../LoginScreen/AddAdminModal";
const Users = ({ Ip }) => {
  const { isDark } = useContext(ThemeContext);

  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);

  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    role: "",
    password: "",
  });

  const closeModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setFormData({
      id: "",
      username: "",
      email: "",
      role: "",
      password: "",
    });
  };

  const handleUserAdded = () => {
    fetchUsers(); 
    setShowModal(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const getRoleFromAccessLvl = (accessLvl) => {
    switch (accessLvl) {
      case 1:
        return "Admin";
      case 2:
        return "Editor";
      case 3:
        return "Viewer";
      default:
        return "Unknown";
    }
  };

  const fetchUsers = async () => {
    try {
      const formData = new FormData();
      formData.append("Action", "fetchAll");
      const res = await axios.post(`${Ip}/Dashboard/admin_dash.php`, formData);

      if (res.data.success) {
        setUsers(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ================================
  // HANDLE INPUT
  // ================================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ================================
  // ADD USER
  // ================================
  // const handleAdd = async () => {
  //   try {
  //     const form = new FormData();
  //     form.append("action", "add");

  //     Object.entries(formData).forEach(([key, value]) => {
  //       if (key !== "id") form.append(key, value);
  //     });

  //     const res = await axios.post(`${Ip}/Controllers/users.php`, form);

  //     if (res.data.success) {
  //       Swal.fire("Success", "User added successfully", "success");
  //       fetchUsers();
  //       closeModal();
  //     } else {
  //       Swal.fire("Error", "Failed to add user", "error");
  //     }
  //   } catch {
  //     Swal.fire("Error", "Something went wrong", "error");
  //   }
  // };

  // ================================
  // EDIT USER
  // ================================
  const handleEdit = (user) => {
    setFormData(user);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleUpdate = async () => {
    try {
      const form = new FormData();
      form.append("action", "edit");

      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });

      const res = await axios.post(`${Ip}/Controllers/users.php`, form);

      if (res.data.success) {
        Swal.fire("Updated", "User updated successfully", "success");
        fetchUsers();
        closeModal();
      } else {
        Swal.fire("Error", "Update failed", "error");
      }
    } catch {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  // ================================
  // DELETE USER
  // ================================
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This admin will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const form = new URLSearchParams();
          form.append("Action", "delete_admin");
          form.append("id", id);
          const res = await axios.post(`${Ip}/Dashboard/admin_dash.php`, form);
          if (res.data.success) {
            Swal.fire("Deleted!", "Admin removed.", "success");
            fetchUsers();
          } else {
            Swal.fire("Error", "Delete failed", "error");
          }
        } catch {
          Swal.fire("Error", "Something went wrong", "error");
        }
      }
    });
  };

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Admin Management</h1>
        <button
          onClick={() => setShowModal(true)}
          className="bg-light-brand dark:bg-dark-brand text-white px-4 py-2 rounded-lg"
        >
          + Add Admin
        </button>
      </div>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search user..."
        className="mb-4 w-full md:w-80 p-2 rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface"
        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
      />

      {/* TABLE */}
      <div className="overflow-x-auto rounded-lg border border-light-border dark:border-dark-border">
        <table className="w-full text-left">
          <thead className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft">
            <tr>
              <th className="p-3">ID</th>
              <th className="p-3">Username</th>
              <th className="p-3">Email</th>
              <th className="p-3">Phone Number</th>
              <th className="p-3">Role</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users
              .filter((u) =>
                Object.values(u).some((val) =>
                  val?.toString().toLowerCase().includes(searchTerm),
                ),
              )
              .map((user) => {
                const role = getRoleFromAccessLvl(user.accessLvl);
                return (
                  <tr key={user.id} className="border-t">
                    <td className="p-3">{user.id}</td>
                    <td className="p-3">{user.username}</td>
                    <td className="p-3">{user.email}</td>
                    <td className="p-3">{user.number}</td>
                    <td className="p-3">{role}</td>
                    <td className="p-3 flex gap-2">
                      <button
                        onClick={() => handleEdit(user)}
                        className="bg-blue-500 text-white px-3 py-1 rounded-md"
                      >
                        <MdModeEdit />
                      </button>
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded-md"
                      >
                        <MdOutlineDeleteForever />
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {showModal && (
        <AddAdminModal
          Ip={Ip}
          showModal={showModal}
          closeModal={closeModal}
          onUserAdded={handleUserAdded}
        />
      )}
    </div>
  );
};

export default Users;
